module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dy-item-wrap', {
    attrs: {
      "item": _vm.item
    }
  }, [_c('el-rate', _vm._g(_vm._b({
    attrs: {
      "colors": ['#99A9BF', '#F7BA2A', '#FF9900'],
      "text-color": "#ff9900"
    }
  }, 'el-rate', _vm.$attrs, false), _vm.$listeners))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03fb3b9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/widgets/RateWidget.vue
// module id = 708
// module chunks = 20